import styled from 'styled-components';
import { PALETTE_COLORS, SEMANTIC_COLORS } from '@/constant/unit/color';
import { SLIDE_SWITCH_TRANSITION_SECOND } from '../../../config/ui/time';
const PREV_NEXT_BUTTON_STYLE = `
position: absolute;
top: 50%;

display: flex;
align-items: center;
justify-content: center;

width: 40px;
height: 40px;
background: none;
border: 2px solid ${SEMANTIC_COLORS.PRIMARY_BORDER};
border-radius: 50%;

opacity: 0.9;
transform: translateY(-50%);
`;
export const S = {
    /* Carousel */
    CarouselContainer: styled.div `
    /* for prev & next button layout */
    position: relative;
    width: 100%;
  `,
    CarouselView: styled.div `
    overflow-x: hidden;
  `,
    LayoutCarouselItems: styled.div `
    display: grid;
    grid-template-rows: 1;
    grid-template-columns: repeat(${(props) => props.itemCount}, calc(100% - 68px - 68px));
    column-gap: 56px;

    transition: ${(props) => props.shouldStartTransition ? `transform ${SLIDE_SWITCH_TRANSITION_SECOND}s` : 'none'};
    transform: ${(props) => `translateX(${props.translateValue}px)`};
  `,
    PrevButton: styled.button `
    ${PREV_NEXT_BUTTON_STYLE};
    left: 20px;
    cursor: pointer;
  `,
    NextButton: styled.button `
    ${PREV_NEXT_BUTTON_STYLE};
    right: 20px;
    cursor: pointer;
  `,
    LayoutNavigationDots: styled.div `
    display: flex;
    justify-content: center;

    margin-top: 17px;
  `,
    NavigationDot: styled.div `
    width: 10px;
    height: 10px;
    margin: 0 3.5px;
    background: ${(props) => props.isActive ? PALETTE_COLORS.PRIMARY_500 : PALETTE_COLORS.PRIMARY_200};

    border-radius: 50%;
  `,
    /* SlideCard */
    SlideCard: styled.div `
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    align-self: stretch;

    width: 100%;
    padding: ${(props) => (props.isActive ? '18px 20px' : '20px')};
    overflow: hidden;

    background: ${SEMANTIC_COLORS.PRIMARY_CARD_BACKGROUND};
    border: ${(props) => props.isActive
        ? `4px solid ${SEMANTIC_COLORS.PRIMARY_BORDER}`
        : `2px solid ${SEMANTIC_COLORS.PRIMARY_BORDER}`};
    border-radius: 10px;
    box-shadow: ${(props) => (props.isActive ? '2px 8px 15px 5px rgba(56, 55, 53, 0.1)' : 'none')};
  `,
};
